import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=4bbc8bde&"
import script from "./TermsList.vue?vue&type=script&lang=js&"
export * from "./TermsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports